module.exports = __webpack_public_path__ + "static/dracaena-trifasciata-499092f581f21e42ae2f93f832655a33.svg";